import "babel-polyfill"
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCompositionAPI from '@vue/composition-api'
import { createPinia, PiniaVuePlugin } from 'pinia'
import '@/assets/global.css';
import './assets/resest.css'

import "./components";
import vueToPdf from 'vue-to-pdf';
import VueEasyPrinter from 'vue-easy-printer';



// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.use(vueToPdf);
Vue.use(VueEasyPrinter);
import Cookies from 'js-cookie'
Vue.prototype.$cookies = Cookies
//第三方组件
import Print from 'vue-print-nb';
Vue.use(Print);



// 引入form-create 表单生成器
import formCreate from "@form-create/element-ui"

Vue.use(formCreate);

Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

new Vue({
    render: h => h(App),
    router,
    pinia
}).$mount('#app')
